// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__188QZ","darkBackground":"Footer_darkBackground__2iRaZ","copyright":"Footer_copyright__2wqDr","tncLink":"Footer_tncLink__1md6B"};